var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "rsp2DropPop" }, [
    _c("span", [_vm._v(_vm._s(_vm.label) + ":")]),
    _vm._v(" "),
    _c(
      "span",
      {
        staticClass: "dpSelection",
        on: {
          click: function($event) {
            _vm.showDropDown = !_vm.showDropDown
          }
        }
      },
      [_vm._v(_vm._s(_vm.selectedItem.label))]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showDropDown,
            expression: "showDropDown"
          }
        ],
        staticClass: "dpPopUp"
      },
      [
        _c(
          "ul",
          _vm._l(_vm.items, function(item) {
            return _c("li", { key: item.id }, [
              _c("label", [
                _c("input", {
                  attrs: { type: "radio", name: "sortBy" },
                  domProps: { value: item.value, checked: item.selected },
                  on: {
                    click: function($event) {
                      _vm.selectItem(item)
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "dpBox" }),
                _vm._v(" "),
                _c("span", { staticClass: "dpLabel" }, [
                  _vm._v(_vm._s(item.label))
                ])
              ])
            ])
          })
        )
      ]
    ),
    _vm._v(" "),
    _c("i", [_vm._v("c")])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }